import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../core/environment/environment.service";
import * as i3 from "../sdk-analytics/sdk-analytics.service";
var DatadogService = /** @class */ (function () {
    function DatadogService(http, environmentService, sdkAnalyticsService) {
        this.http = http;
        this.environmentService = environmentService;
        this.sdkAnalyticsService = sdkAnalyticsService;
    }
    DatadogService.prototype.isInternalNetwork = function (url) {
        return this.http.get(url + '/hello', { responseType: "json" }).pipe(map(function () { return true; }), // Return true if status code is 200
        catchError(function (error) {
            if (error.status === 200) {
                return of(true); // Return true if status code is 200
            }
            return of(false); // Return false for other errors
        }));
    };
    DatadogService.prototype.configureDataDog = function () {
        var _this = this;
        // get env do en4 --- en4
        this.environmentService
            .loadEnvironment()
            .subscribe(function (res) {
            _this.envDatadog = res.datadogSettings; //set env
            // --- en4
            // --- datadog
            _this.isInternalNetwork(_this.envDatadog.ddproxy)
                .subscribe(function (internal) {
                console.log('isInternalNetwork', internal);
                _this.initializeDatadog(internal);
            });
            // --- datadog
            // --- en4
        });
        // --- en4
    };
    DatadogService.prototype.initializeDatadog = function (internal) {
        var config = {
            name: this.envDatadog.name,
            version: this.envDatadog.version,
            env: this.envDatadog.environment,
            sigla: this.envDatadog.sigla,
            datadog: {
                logs: {
                    clientToken: this.envDatadog.proxyToken,
                    proxy: internal ? this.envDatadog.ddproxy : undefined,
                    maskSensitiveData: true
                },
                rum: {
                    applicationId: this.envDatadog.applicationId,
                    clientToken: this.envDatadog.proxyToken,
                    sessionSampleRate: this.envDatadog.sessionSampleRate,
                    proxy: internal ? this.envDatadog.ddproxy : undefined,
                    trackViewsManually: true,
                    maskSensitiveData: true
                }
            },
            externalApplication: false,
        };
        if (!internal) {
            config.datadog.logs.clientToken = this.envDatadog.clientTokenExt;
            config.datadog.rum.clientToken = this.envDatadog.clientTokenExt;
            config.externalApplication = true;
        }
        this.sdkAnalyticsService.configureDatadog(config);
    };
    /**
     * Método que envia o erro para o datadog via SDK.
     * @param {string} message - mensagem que será enviada para ferramenta.
     * @param {object} context - contexto adicional do erro.
     */
    DatadogService.prototype.sendErrorLogs = function (message, context) {
        if (context === void 0) { context = {}; }
        this.sdkAnalyticsService.sendDatadogErrorLog(message, context);
    };
    /**
     * Método que envia o log informativo para o datadog via SDK.
     * @param {string} message - mensagem que será enviada para ferramenta.
     * @param {object} context - contexto adicional do log.
     */
    DatadogService.prototype.logInfo = function (message, context) {
        if (context === void 0) { context = {}; }
        this.sdkAnalyticsService.sendDatadogInfoLog(message, context);
    };
    /**
     * Método que envia o view para o datadog RUM via SDK.
     * @param {string} pagina - nome da página.
     * @param {object} contexto - contexto adicional da view.
     */
    DatadogService.prototype.sendStartView = function (pagina, contexto) {
        this.sdkAnalyticsService.sendDatadogStartView(pagina, contexto || {});
    };
    /**
     * Método que envia o user para o datadog RUM via SDK.
     * @param {string} _id - ID do usuário.
     * @param {string} _name - nome do usuário.
     */
    DatadogService.prototype.sendSetUser = function (_id, _name) {
        this.sdkAnalyticsService.sendDatadogSetUser(_id, _name);
    };
    /**
    * Método utilizado pelo MFE para enviar logs de erro para o datadog.
    */
    DatadogService.prototype.sendErrorLogsChildren = function (payload) {
        var analytics = payload.analytics;
        if (!this.validatePayload(analytics, 'dd'))
            return;
        var _a = this.formatMessage(analytics), message = _a.message, context = _a.context;
        this.sendErrorLogs(message, context);
    };
    DatadogService.prototype.validatePayload = function (payload, key) {
        return payload && typeof payload === 'object' && key in payload;
    };
    DatadogService.prototype.formatMessage = function (payload) {
        var _a = payload.dd, applicationUrl = _a.applicationUrl, statusCode = _a.statusCode, name = _a.name, erro = _a.erro, api = _a.api, ambiente = _a.ambiente, message = "status: " + statusCode + " nome-mfe: " + name + " url: " + applicationUrl, context = { erro: erro + ", api: " + api + ", ambiente: " + ambiente, name: name };
        return { message: message, context: context };
    };
    DatadogService.ngInjectableDef = i0.defineInjectable({ factory: function DatadogService_Factory() { return new DatadogService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService), i0.inject(i3.SdkAnalyticsService)); }, token: DatadogService, providedIn: "root" });
    return DatadogService;
}());
export { DatadogService };
